const ClipboardCheckIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.08337 3.3335H5.33337C4.2288 3.3335 3.33337 4.22893 3.33337 5.3335V16.3335C3.33337 17.4381 4.2288 18.3335 5.33337 18.3335H10"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path d="M12.9166 3.3335H14.6666C15.7712 3.3335 16.6666 4.22893 16.6666 5.3335V12.5002" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path
      d="M6.66663 5.25657V3.75016C6.66663 3.52004 6.85317 3.3335 7.08329 3.3335C7.31341 3.3335 7.50348 3.14687 7.54289 2.92015C7.66636 2.20992 8.14495 0.833496 9.99996 0.833496C11.855 0.833496 12.3336 2.20992 12.457 2.92015C12.4964 3.14687 12.6865 3.3335 12.9166 3.3335C13.1467 3.3335 13.3333 3.52004 13.3333 3.75016V5.25657C13.3333 5.5752 13.075 5.8335 12.7564 5.8335H7.24355C6.92492 5.8335 6.66663 5.5752 6.66663 5.25657Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path d="M12.9166 17.0835L14.5833 18.7502L18.75 14.5835" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default ClipboardCheckIcon;
